<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-lamp`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.147 4.824A1 1 0 0037.163 4H10.837a1 1 0 00-.984.824l-4.643 26A1 1 0 006.194 32H22v9h-7a1 1 0 00-1 1v2a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1h-7v-9h15.807a1 1 0 00.984-1.176l-4.643-26zM13.35 8H34.65l3.571 20H9.778l3.57-20z"/></svg>
</template>
<script>

export default {
  name: 'IconLamp',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
